import type { Step } from "@/types/steps.types";
import { STEP_ID, STEP_IS_VISIBLE } from "@/types/steps.types";

const steps: Step[] = [
  {
    id: STEP_ID.PRESCRIPTION_TYPE,
    title: "steps.prescriptionType.title",
    description: "steps.prescriptionType.description",
    isVisible: [
      STEP_IS_VISIBLE.USER_LOGGED,
      STEP_IS_VISIBLE.USER_HAS_SAVED_PRESCRIPTION,
    ],
  },
  {
    id: STEP_ID.ADVANCED_PRESCRIPTION,
    manualTitle: "steps.advancedPrescription.manualTitle",
    manualDescription: "steps.advancedPrescription.manualDescription",
    accountTitle: "steps.advancedPrescription.accountTitle",
    accountDescription: "steps.advancedPrescription.accountDescription",
  },
  {
    id: STEP_ID.ADD_PRODUCT,
    title: "steps.addProduct.title",
    isVisible: [STEP_IS_VISIBLE.PRODUCT_SELECTED],
  },
];

export default steps;
